/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  created_on: ['created_on:gte', 'created_on:lte'],
  load_weight_min: 'load_weight:gte',
  load_weight_max: 'load_weight:lte',
  load_volume_min: 'load_volume:gte',
  load_volume_max: 'load_volume:lte',
  shipped_customer_id: 'shipped_customer.id:in',
  destination_address_id: 'destination_address.id:in',
  destination_address_province: 'destination_address.province:in',
  destination_address_city: 'destination_address.city:in',
  expected_delivered_on: ['expected_delivered_on:gte', 'expected_delivered_on:lte'],
  product_category: 'product_category.id:in',
  destination_address_category: 'destination_address_category:in',
  line_order: 'line_order',
}

export default parseFilterDataMapping
